import { DataService } from './../../../shared/service/data.service';
import { Component, OnInit, ChangeDetectorRef, TemplateRef, ViewChild, ViewChildren, QueryList } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CommonHelper } from "src/app/helper/helper.component";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from "@angular/router";
import { DatePipe } from '@angular/common';
import { FileUploader } from 'ng2-file-upload';
import { MasterService } from "../../master/services/master-service";
import { CommonConstants } from 'src/app/shared/constants';
import { GrievanceDetailsPopupComponent } from '../../../shared/grievance-details-popup/grievance-details-popup.component';
import { GrievanceDetailsService } from '../../../shared/grievance-details-popup/grievance-details.service'
import { GrievanceViewService } from '../../../shared/grievance-time-line-details/grievance-time-line-details.service';
import { DataTableDirective } from 'angular-datatables';

declare var $: any;

@Component({
  selector: 'app-level-dashboard',
  templateUrl: './level-dashboard.component.html',
  styleUrls: ['./level-dashboard.component.scss'],
  providers: [MasterService, CommonHelper, DatePipe]
})
export class LevelDashboardComponent implements OnInit {
  @ViewChild('uploaderInput')
  dataTable: any;
  modalRef: BsModalRef;
  allGreviancesData: any;
  registerGrievancesData: any;
  pendingGreviancesData: any;
  closedGrevianceData: any;
  districtsData: any;
  categoryData: any;
  beneficaryStatusDetails: any;
  categoriesNature: any;
  adminDashBoardForm: FormGroup;
  allGRegisteredPerMonth: Number;
  allGResolvedPerMonth: Number;
  islevelGrievanceCountExist: boolean = false;
  levelGrievanceData: any;
  grieveancelevelData: any;
  actionTakenData: Array<any> = [];
  totalIPDCount: Number;
  totalOPDCount: Number;
  isDate: boolean = false;
  isTotalIPDCountExist: boolean = false;
  isTotalOPDCountExist: boolean = false;
  gLId: any;
  modalBool: boolean = false;
  modalView: boolean = false;
  grieveanceDetailsData: any;
  grievanceHistoryData: any;
  talukasData: any = [];
  multipleDistrict: any;
  multipleTalukas: any;
  districts: any = [];
  talukas: any = [];
  talukasIds: any = [];
  districtIdsData: any = [];
  counter = 0;
  districtIds = {};

  data: any = {
    grievanceId: '',
    grievanceTypeId: '',
    districtId: '',
    statusId: '',
    startDate: '',
    endDate: ''
  }
  maxDate: any = new Date();
  showPickerStart = false;
  submitted: boolean = false;
  startDateTime: Date = null;
  endDateTime: Date = null;
  showPickerEnd = false;
  showDateEnd = true;
  showTimeEnd = true;
  showDateStart = true;
  showTimeStart = true;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  closeButtonEnd: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  forwardGrievanceActionForm: FormGroup;
  selectedLevel: any;
  forwardLevel: number;
  errorCheck: boolean = false;
  @ViewChild('uploaderInput')
  uploaderInput: any;
  displayLevelGrievanceData: any;
  statesData: any;
  levelGrievanceActionForm: FormGroup;
  levelsData: any;
  recordIdDeletePhoto: [];
  imageData = [];
  activeTab: string;
  actionLevelId: number;
  levelGrievanceActionData: any;
  isStatus: boolean = false;
  fileUploadData: Array<any> = [];
  newgrievanceData: any;
  delUndoGrievnceData: any;
  isnewGrievanceCountExists: boolean = false;
  newGrievanceCount: any;
  popUpCnfMessage: string;
  delUndoGrievnceHeading: string;
  griId: string;
  gStatus: string;
  submit: boolean = true;
  submits: boolean = true;
  redressedStatusData = [];
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  public uploader: FileUploader = new FileUploader({ url: '', });
  allLevelGrievanceData: any;
  currentLevelName: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings[] = [];
  currentpage: number;
  filterdata: { districtId: string; blockId: string; endDate: string; grievanceId: string; grievanceTypeId: string; grievanceNatureId: string;  levelType: string; startDate: string; status: string; };

  isacceptedGrievanceCountExists: boolean;
  isAllGrievanceCountExists: boolean;
  gId: any;
  categoriesNature1: any[];
  selectedNature: any;
  natureId: any;


  constructor(
    private spinner: NgxSpinnerService,
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private route: Router,
    private commonHelper: CommonHelper,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    private grievanceDetailsPopupModal: GrievanceDetailsService,
    private grievanceViewService: GrievanceViewService,
    public dataService: DataService,
  ) { }

  ngOnInit() {
    this.actionLevelId = parseInt(localStorage.getItem('levelId'));
    this.currentLevelName = localStorage.getItem('levelName');
    this.getDistricts(CommonConstants.stateId);
    this.getCategory();
    this.getGrievanceNature(1);
    this.getLevelList(this.data);
    this.getAllLevelList(this.data);
    this.allLevelGrievanceCount();
    this.validationsForFilters();
    this.countOfIPDFeedback();
    this.getAllNewGrievanceData(this.data);
    this.countOfOPDFeedback();
    this.getStatus()
    // this.getAllAcceptedGrievanceData(this.data);
    this.redressedStatusData = CommonConstants.statusActionGrievance;
  }
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;

    this.uploader.onAfterAddingFile = (photoId) => {
      photoId.withCredentials = false;
    };
  }
  removePhotoId(index) {
    this.uploader.queue.splice(index, 1)
  }

  /* function for getting the status*/
  getStatus() {
    this.beneficaryStatusDetails = [
      { id: '', color: "", name: "", dpname: "All" },
      { id: 1, color: "White", name: "withInSevenDays", dpname: "Within 7 days" },
      { id: 2, color: "Yellow", name: "processing", dpname: "Processing" },
      { id: 3, color: "Red", name: "notRedressed", dpname: "Not Redressed within 7 days" },
      { id: 4, color: "Green", name: "redressed", dpname: "Redressed" }
    ];
  }

  //Resetting the input
  resetUploader(inputId) {
    if (inputId == 1) {
      this.uploaderInput.nativeElement.value = "";
    }
  }

  /**getCategory
   *
   *
   */
  getCategory() {
    this.apiCallingNoState("active_grievanceType");
  }
  /**getGrievanceNature
   *
   * @param stateId
   */
  getGrievanceNature(stateId) {
    this.apiCalling("active_grievanceNature", stateId);
  }

  /**GetDistricts
   *
   * @param stateId
   */
  getDistricts(stateId: number) {
    // this.apiCalling("active_districts", stateId);
    this.apiCalling("role_based/districts", stateId);
  }

  /**GetLevel
 *
 * @param stateId
 */
  getLevel(stateId) {
    this.apiCalling("active_levels", stateId);
  }
  /**
   *
   * @param url
   * @param id
   */
  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + "/", id).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**
 *
 * @param url
 * @param id
 */
  apiCallingNoState(url: string) {
    try {
      this.spinner.show();
      this.masterService.getAll(url).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**Databinding to UI
   *
   * @param url
   * @param response
   */
  dataBinding(url: string, response: any) {
    if (url === "role_based/districts") {
      if (response.data[0].districts.length > 0) {
        this.spinner.hide();
        // response.data[0].districts.unshift({
        //   code: 'all',
        //   description: "",
        //   displayName: "All",
        //   districtId: "all",
        //   name: 'all',
        //   status: 'active'
        // })
        response.data[0].districts.sort(function (a, b) { return a.name - b.name });
        this.districtsData = response.data[0].districts;
      } else {
        this.districtsData = [];
        this.spinner.hide();
      }
    } else if (url === "active_grievanceType") {
      if (response.data.length > 0) {
        this.spinner.hide();
        response.data.push({
          description: "",
          grievanceTypeId: "",
          name: 'all',
          status: 'active'
        })
        response.data.sort(function (a, b) { return a.grievanceTypeId - b.grievanceTypeId });
        this.categoryData = response.data;
      } else {
        this.spinner.hide();
        this.categoryData = [];
      }
    } else if (url === "active_grievanceNature") {
      let newData = [];
      response.data.filter((newResponse: any) => {
        newData.push({
          id: newResponse.grievanceNatureId,
          name: newResponse.grievanceNatureName
        });
      });
      if (newData.length > 0) {
        this.spinner.hide();
        this.categoriesNature = newData;
      } else {
        this.spinner.hide();
        this.categoriesNature = [];
      }
    }
    if (url === 'active_levels') {
      if (response.data[0].levels.length > 0) {
        this.spinner.hide();
        this.levelsData = response.data[0].levels;
        this.levelsData = this.levelsData.filter(levels => levels.levelId != this.actionLevelId);
        this.selectedLevel = this.levelsData[0];
      } else {
        this.levelsData = [];
        this.spinner.hide();
      }
    }
  }

  // get levels
  getLevels(stateId: number, gId: number) {
    try {
      this.spinner.show();
      this.masterService.getLevels("levels/", CommonConstants.stateId, this.forwardLevel).subscribe(
        (response: any) => {
          if (response.data.levels.length > 0) {
            this.spinner.hide();
            this.levelsData = response.data.levels
            this.selectedLevel = response.data.levels[0];
          } else {
            this.levelsData = [];
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }


  validationsForFilters() {
    this.adminDashBoardForm = this.fb.group({
      selectedDistrict: [],
      selectedGrievanceId: [],
      selectedGrievanceType: [],
      addUserBlockLocation: [],
      selectedStatus: [],
      startDateTime: [''],
      endDateTime: [''],
      filterGrievanceNature:[]
    });
  }
  /**API calling method
   *
   * @param url
   * @param greviancesType
   */
  allLevelGrievanceCount() {
    try {
      this.spinner.show();
      this.masterService.alllevelGrievanceCount('total_grievance_monthly').subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.islevelGrievanceCountExist = true;
            this.allGRegisteredPerMonth = response.data[0].totalRegistered;
            this.allGResolvedPerMonth = response.data[0].totalResolved;
          } else {
            this.spinner.hide();
            this.islevelGrievanceCountExist = false;
            if(this.allGRegisteredPerMonth === 0 || this.allGResolvedPerMonth === 0){
              this.islevelGrievanceCountExist = true;
            }
            
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  // all Greviances under one 
  getAllLevelList(data: any) {
    const that = this;
    this.filterdata = {
      'districtId': data.districtId,
      'endDate': data.endDate,
      'grievanceId': data.grievanceId,
      'grievanceTypeId': data.grievanceTypeId,
      'grievanceNatureId': data.grievanceNatureId,
      'blockId': data.blockId,
      'levelType': data.levelType,
      'startDate': data.startDate,
      'status': data.status
    }
    try {
      this.spinner.show();
      this.dtOptions[2] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: true,
        destroy:true, //Add to allow the datatable to destroy
        ajax: (dataTablesParameters: any, callback) => {
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
          this.masterService.getLevelGrievancesList('grievances_based_on_level/'+dataTablesParameters.length+'?page='+that.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response.data.data.length > 0) {
                // response.data.map(data => {
                //   // *ngIf="levelData.status == 'pending' || levelData.status == 'accepted'"
                // })
                this.spinner.hide();

                // this.reploatingDataTable('dataTable3');

                this.isAllGrievanceCountExists = true;
                this.allLevelGrievanceData = response.data.data;
                //this.levelGrievanceData = [];
                if (this.submit == true) {
                  // const table: any = $("table");
                  this.chRef.detectChanges();
                  // this.dataTable = $("#dataTable3").DataTable({ "order": [], "destroy": true }).draw();
                }
                // console.log(this.submit)
              } else {
                this.spinner.hide();
                this.allLevelGrievanceData = [];
                this.isAllGrievanceCountExists = false;
                if(this.allLevelGrievanceData.length === 0){
                  this.isAllGrievanceCountExists = true;
                }
                

                // $("#dataTable3").DataTable().destroy();
                // this.chRef.detectChanges();
                // $("#dataTable3").DataTable({
                //   language: {
                //     emptyTable: "No data available in table", //
                //     loadingRecords: "Please wait .. ", // default Loading...
                //     zeroRecords: "No records found"
                //   }
                // });
                // $("#dataTable3").DataTable().draw();
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []
              });
            },
            error => {
              this.spinner.hide();
            }
          );
        },
        columns: [{ data: 'grievance_id' }, { data: 'created_at' }]
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }



  /*getData bind table data */
  getLevelList(data: any) {
    const that = this;
    this.filterdata = {
      'districtId': data.districtId,
      'endDate': data.endDate,
      'grievanceId': data.grievanceId,
      'grievanceTypeId': data.grievanceTypeId,
      'grievanceNatureId': data.grievanceNatureId,
      'blockId': data.blockId,
      'levelType': data.levelType,
      'startDate': data.startDate,
      'status': data.status
    }
    try {
      this.spinner.show();
      this.dtOptions[0] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: true,
        destroy:true, //Add to allow the datatable to destroy
        ajax: (dataTablesParameters: any, callback) => {
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
          this.masterService.getLevelGrievancesList('level_user/grievance_list/'+dataTablesParameters.length+'?page=' + that.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response.data.data.length > 0) {
                // response.data.map(data => {
                //   // *ngIf="levelData.status == 'pending' || levelData.status == 'accepted'"
                // })
                this.spinner.hide();

                // this.reploatingDataTable('dataTable1');
                this.isacceptedGrievanceCountExists = true;
                this.levelGrievanceData = response.data.data;
                // console.log(this.levelGrievanceData)
                //this.levelGrievanceData = [];
                if (this.submit == true) {
                  // const table: any = $("table");
                  this.chRef.detectChanges();
                  // this.dataTable = $("#dataTable1").DataTable({ "order": [], "destroy": true }).draw();
                }
                // console.log(this.submit)
              } else {
                this.spinner.hide();
                this.levelGrievanceData = [];
                this.isacceptedGrievanceCountExists = false;
                if(this.levelGrievanceData.length === 0){
                  this.isacceptedGrievanceCountExists = true;
                }
                // $("#dataTable1").DataTable().destroy();
                this.chRef.detectChanges();
                // $("#dataTable1").DataTable({
                //   language: {
                //     emptyTable: "No data available in table", //
                //     loadingRecords: "Please wait .. ", // default Loading...
                //     zeroRecords: "No records found"
                //   }
                // });
                // $("#dataTable1").DataTable().draw();
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []
              });
            },
            error => {
              this.spinner.hide();
            }
          );
        },
        columns: [{ data: 'grievance_id' }, { data: 'created_at' }]
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }


  /* all New Greviances*/
  getAllNewGrievanceData(data: any) {
    const that = this;
    this.filterdata = {
      'districtId': data.districtId,
      'endDate': data.endDate,
      'grievanceId': data.grievanceId,
      'grievanceTypeId': data.grievanceTypeId,
      'grievanceNatureId': data.grievanceNatureId,
      'blockId': data.blockId,
      'levelType': data.levelType,
      'startDate': data.startDate,
      'status': data.status
    }
    try {
      this.spinner.show();
      this.dtOptions[1] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: true,
        destroy:true, //Add to allow the datatable to destroy
        ajax: (dataTablesParameters: any, callback) => {
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
          this.masterService.getAllNewGrievances('new_grievances/level_user/'+dataTablesParameters.length+'?page=' + that.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response.data.data.length > 0) {
                this.spinner.hide();
                // this.reploatingDataTable('datatable2');
                this.isnewGrievanceCountExists = true;
                this.newgrievanceData = response.data.data;
                this.newGrievanceCount = response.data.data.length;
                this.chRef.detectChanges();
                // this.dataTable = $("#dataTable2").DataTable({ "order": [] }).draw();
              } else {
                this.spinner.hide();
                // $("#dataTable2").DataTable().destroy();
                this.isnewGrievanceCountExists = false;
                this.newgrievanceData = [];
                if(this.newgrievanceData.length === 0){
                  this.isnewGrievanceCountExists = true;
                }
                this.chRef.detectChanges();
                // $("#dataTable2").DataTable({
                //   language: {
                //     emptyTable: "No data available in table", //
                //     loadingRecords: "Please wait .. ", // default Loading...
                //     zeroRecords: "No records found"
                //   }
                // });
                // $("#dataTable2").DataTable().draw();
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []
              });
            },
            error => {
              this.spinner.hide();
            }
          );
        },
        columns: [{ data: 'grievance_id' }, { data: 'created_at' }]
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }



  /*redraw the datatable*/
  reploatingDataTable(value) {
    let table;
    if (value == 'datatable1') {
      table = $("#dataTable1").DataTable();
    } else {
      table = $("#dataTable2").DataTable();
    }

    table.destroy();
  }

  /*route grievance history screen */
  userDescriptionModal(formData) {
    this.route.navigateByUrl("/grievance-history");
    localStorage.setItem("grievanceId", formData.id);
  }

  /* Showing grievance Modal Popup on click of grievamce Id*/
  grievanceDetailsModal(levelData) {
    // console.log(levelData)
    this.modalBool = true;
    this.masterService.getGrievanceDetails('grievance_details/', levelData).subscribe(
      (response: any) => {
        if (response.data.length > 0) {
          this.grieveanceDetailsData = response.data[0];
          this.getFiles(levelData);
        } else {
          this.spinner.hide();
        }
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  grievanceActionModal(template: TemplateRef<any>, levelData) {
    this.submitted = false;
    this.getFiles(levelData);
    this.levelGrievanceActionData = levelData;
    console.log(this.currentLevelName)
    this.uploader.queue = [];
    this.isStatus = false;
    this.validationsLevelGrievanceAction();
    this.closeModal()
    this.closeViewModal()
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'grievance-modal-wrapper' }));

  }

  /**addLevelGrievanceDetails
  * 
  */
  validationsLevelGrievanceAction() {
    this.levelGrievanceActionForm = this.fb.group({
      grievanceId: [this.levelGrievanceActionData.id],
      actionLevelId: [this.actionLevelId, [Validators.required]],
      comment: ['', [Validators.required, Validators.maxLength(150)]],
      isGrievanceRedressed: ['0', Validators.required],
    });
    this.levelGrievanceActionForm.removeControl('redressedStatus')
  }


  /* get IPD-Feedback Count*/
  countOfOPDFeedback() {
    try {
      this.spinner.show();
      this.masterService.getOPDFeedBackCount('total_opd_feedback').subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.totalOPDCount = response.data[0].opdFeedback;
            this.isTotalOPDCountExist = true
          } else {
            this.spinner.hide();
            this.isTotalOPDCountExist = true
            this.totalOPDCount = 0;
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }

  /* get IPD-Feedback Count*/
  countOfIPDFeedback() {
    try {
      this.spinner.show();
      this.masterService.getIPDFeedBackCount('total_ipd_feedback').subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.isTotalIPDCountExist = true
            this.totalIPDCount = response.data[0].ipdFeedback;
          } else {
            this.spinner.hide();
            this.isTotalIPDCountExist = false
            this.totalIPDCount = 0;

          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }


  /*routing grievance history screen */
  viewTimeLineGrievance(id) {
    this.modalBool = false;
    this.modalView = true;
    this.masterService.getData("grievance_history/", id).subscribe(
      (response: any) => {
        if (response) {
          this.spinner.hide();
          this.grievanceHistoryData = response.data;
          this.openViewModal();
        } else {
          this.spinner.hide();
          this.grievanceHistoryData = [];

        }
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  /* Function for Opening the View Model*/
  openViewModal() {
    this.grievanceViewService.open();
  }

  closeViewModal() {
    this.grievanceViewService.close();
  }

  checkRedressal(value) {
    if (value == '1') {
      this.isStatus = true;
      this.levelGrievanceActionForm.addControl('redressedStatus', new FormControl([], Validators.required));
      this.levelGrievanceActionForm.addControl('redressedComment', new FormControl(''));
    } else if (value == '0') {
      this.isStatus = false;
      this.levelGrievanceActionForm.removeControl('redressedStatus')
    }
  }
  //get f() { return this.addStateForm.controls; }
  get addlevelGrievanceF() {
    return this.levelGrievanceActionForm.controls;
  }
  addLevelGrievanceAction() {
    this.submitted = true;
    this.submit = false
    // console.log(this.submit)
    this.imageData = [];
    let fileLength;
    fileLength = this.uploader.queue
    let fileCount: number = fileLength.length;
    if (fileCount > 0) {
      fileLength.forEach((val, i, array) => {
        let fileReader = new FileReader();
        fileReader.onloadend = (e) => {
          this.imageData.push(fileReader.result);
        }
        fileReader.readAsDataURL(val._file);
      });
    }
    if (this.levelGrievanceActionForm.invalid) {
      this.spinner.hide();
      return;
    }
    let redrssStatus;
    let apiData = this.levelGrievanceActionForm.value, data: any;
    if (this.isStatus == false) {
      if (apiData.redressedStatus == undefined) {
        redrssStatus = apiData.redressedStatus = "";
      }
    } else if (this.isStatus == true) {
      redrssStatus = apiData.redressedStatus.dpname;
    }
    setTimeout(() => {
      data = {
        grievanceId: apiData.grievanceId ? apiData.grievanceId : '',
        levelId: apiData.actionLevelId ? apiData.actionLevelId : '',
        comment: apiData.comment ? apiData.comment : '',
        file: this.imageData,
        isGrievanceRedressed: parseInt(apiData.isGrievanceRedressed),
        redressedStatus: redrssStatus ? redrssStatus : '',
        redressedComment: apiData.redressedComment ? apiData.redressedComment : ''
      }
      this.apiCallForPostData("level/grievance_action", data);
    }, 500)
  }
  apiCallForPostData(url: string, data: any) {
    try {
    this.spinner.show();
    this.masterService.postData(url, data).subscribe((response: any) => {
      if (response) {
        this.spinner.hide();
        if (url === 'level/grievance_action') {
          if (response.status) {
            // this.spinner.hide();
            this.commonHelper.toasterMessage(response.message);
            this.spinner.hide();
            this.levelGrievanceActionForm.reset();
            this.uploader.queue = [];
            this.submitted = false;
            this.getLevelList(this.data);

            this.levelGrievanceActionForm.controls['grievanceId'].setValue(this.levelGrievanceActionData.id);
            this.levelGrievanceActionForm.controls['actionLevelId'].setValue(this.actionLevelId);
            this.levelGrievanceActionForm.controls['isGrievanceRedressed'].setValue('0');
            this.isStatus = false;
            this.modalRef.hide();
            this.route.routeReuseStrategy.shouldReuseRoute = function () {
                return false;
              }
              this.route.onSameUrlNavigation = 'reload';
              this.route.navigate(['/level-dashboard'])
          } else {
            this.spinner.hide();
            this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
          }
        }
      } else {
        this.spinner.hide();
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage)
      }
    }, error => {
      this.spinner.hide();
    });
  } catch (exc) {
    this.spinner.hide();
  }
  }
  /*getData bind table data */
  getFiles(levelData) {
    // console.log(levelData)
    try {
      this.spinner.show();
      this.openModal();
      this.masterService.getAll('grievance_uploads/' + levelData).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.actionTakenData = response.data;
            this.actionTakenData.map(item => {
              if (item.isGrievanceRedressed == 1) {
                item.isGrievanceRedressedVal = "Yes";
              } else {
                item.isGrievanceRedressedVal = "No"
              }
              this.fileUploadData = item.uploads
            })
          } else {
            this.spinner.hide();
            this.actionTakenData = [];

          }
        },
        error => {
          this.spinner.hide();
          this.grievanceDetailsPopupModal.open();
        }
      );
    } catch (exc) { }
  }

  /* Open the Grievamce Forward Popup Modal*/
  forwardGrievanceModal(template: TemplateRef<any>, grievanceId, grivanceLId) {
    this.submit = false
    if (this.forwardGrievanceActionForm) {
      this.forwardGrievanceActionForm.reset();
    }
    this.forwardLevel = grievanceId;
    this.gLId = grivanceLId;
    // this.getLevel(CommonConstants.stateId)
    this.getLevels(CommonConstants.stateId, this.forwardLevel)
    this.forwardGrievanceActionForm = this.fb.group({
      level: [this.selectedLevel, [Validators.required]],
      levelfeedback: ['', [Validators.required, Validators.maxLength(250)]]
    });
    this.modalRef = this.modalService.show(template);

  }

  forwardGrivance() {
    try {
      this.spinner.show();
      let apiData = this.forwardGrievanceActionForm.value,
        data = {
          grievanceId: this.forwardLevel,
          levelId: apiData.level.levelId,
          comment: apiData.levelfeedback
        }
      this.modalRef.hide();
      this.masterService.postData('forward_grievance', data).subscribe((response: any) => {
        if (response) {
          this.spinner.hide();
          if (response.data.length > 0) {
            this.getLevelList(this.data);
            this.getAllLevelList(this.data);
            this.commonHelper.toasterMessage(response.message);
            this.spinner.hide();
            this.route.routeReuseStrategy.shouldReuseRoute = function () {
              return false;
            }
            this.route.onSameUrlNavigation = 'reload';
            this.route.navigate(['/level-dashboard'])
          } else {
            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
        }
      });
    } catch (exc) {
      this.spinner.hide();
    }
  }

  /* Opening forward grievance confirmation Popup Model*/
  forwardCnfGrievanceModal(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(template);
  }

  //function to diaable or enable the submit button
  emptyDisable(event) {
    if (event.target.value.length <= 250) {
      this.errorCheck = false;
    } else if (event.target.value.length > 250) {
      this.errorCheck = true;
    }
  }

  // onGrievanceTypeChange(event) {

  // }

  // onStatusChange(event) {

  // }

  submitReport() {
    let apiData = this.adminDashBoardForm.value;
    let grievanceTypeId: any;
    let grievanceNatureId: any;
    let districtId: any;
    let statusId: any;
    let blockId: any;
    let endDatetime: any;
    let startDatetime: any;


    grievanceTypeId = apiData.selectedGrievanceType ? apiData.selectedGrievanceType.grievanceTypeId : '';
    grievanceNatureId = apiData.filterGrievanceNature ? apiData.filterGrievanceNature.id : '';
    districtId = apiData.selectedDistrict ? apiData.selectedDistrict.districtId : '';
    statusId = apiData.selectedStatus ? apiData.selectedStatus.name : '';
    blockId = this.talukasIds.length == 0 ? "" : this.talukasIds
    startDatetime = this.startDateTime ? this.startDateTime : '';
    endDatetime = this.endDateTime ? this.endDateTime : '';

    this.data = {
      districtId: districtId,
      grievanceId: $('#grievanceId').val(),
      grievanceTypeId: grievanceTypeId,
      grievanceNatureId: grievanceNatureId,
      status: statusId,
      startDate: startDatetime,
      endDate: endDatetime,
      blockId: blockId
    }


    /* Validation for Selecting the Start and End Date */
    let sDate = this.datepipe.transform(startDatetime, "yyyy-MM-dd HH:mm:ss"),
      eDate = this.datepipe.transform(endDatetime, "yyyy-MM-dd HH:mm:ss");

    if (sDate) {
      if (eDate) {
        if (sDate >= eDate) {
          this.isDate = true;
        } else {
          this.isDate = false;
        }
      } else {
        this.isDate = false;
      }
    } else {
      this.isDate = false;
    }

    if (this.isDate === false) {
      this.getLevelList(this.data);
      this.getAllNewGrievanceData(this.data)
      this.getAllLevelList(this.data)
    }

    setTimeout(() => {
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      });
    });

  }

  // function to append value in input 
  onValueChange(val: any, endorstart: string) {
    if (endorstart === 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.startDateTime = val;
      this.isDate = false;
    }
    if (endorstart === 'endDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.endDateTime = val;
      this.isDate = false;
    }
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == 'startDT') {
      if (!this.showPickerStart) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (!this.showPickerEnd) {
        this.showPickerEnd = true;
      }
    }
  }
  /* Function for Opening the Password Popup Model*/
  openModal() {

    this.grievanceDetailsPopupModal.open();

  }

  closeModal() {
    this.grievanceDetailsPopupModal.close();
  }

  //change District event
  changeDistrict(event) {
    this.districts = [];
    this.districtIdsData = [];
    this.districtIds = { stateId: CommonConstants.stateId, districtId: event.districtId }
    this.districtIdsData.push(this.districtIds)
    this.districts.push(event.districtId)
    console.log(this.districts)
    this.getBlock()
    this.talukasData = [];
    this.adminDashBoardForm.controls['addUserBlockLocation'].reset();
    // this.districts = [];
    // this.districtIdsData = [];
    // if (event.length == 0) {
    //   this.talukasData = [];
    //   // this.addUserForm.controls['addUserBlockLocation'].reset();
    // } else {
    //   if (event.length != this.counter) {
    //     // this.addUserForm.controls['addUserBlockLocation'].reset();
    //     this.counter = event.length
    //   }
    //   event.map(data => {
    //     this.districtIds = { stateId: CommonConstants.stateId, districtId: data.districtId }
    //     this.districtIdsData.push(this.districtIds)
    //     this.districts.push(data.districtId)
    //     this.getBlock()
    //   })
    // }
  }

  //change Talukas event
  changeTalukas(event) {
    console.log(event)
    this.districtIdsData = [];
    this.talukasIds = [];
    // if(event.name == "All"){

    //   this.adminDashBoardForm.patchValue({addUserBlockLocation:this.talukasData.map((res) => res.talukaId).filter((item) => item)})
    //   console.log(event)
    //   // this.adminDashBoardForm.controls.addUserBlockLocation.setValue(this.talukasData)
    // }
    // else{
    //   this.adminDashBoardForm.controls.addUserBlockLocation.setValue([])
    // }
    event.forEach(data => {
      this.talukasIds.push(data.talukaId)
      this.districtIdsData.push({ stateId: CommonConstants.stateId, talukaId: data.talukaId })
    })
  }

  // get Block 
  getBlock() {
    try {
      let data = {
        "district_id": this.districts
      }
      this.masterService.postData('talukas', data).subscribe((response: any) => {
        this.talukas = [];
        this.talukasData = [];
        if (response.status) {
          // response.data.unshift({
          //   code: "",
          //   description: null,
          //   displayName: null,
          //   name: "All",
          //   status: "active",
          //   talukaId: "all"
          // })
          response.data.map(data => {
            this.talukasData.push(data)
            this.talukas.push(data.name)
          })
        } else {
          this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
        }
      }, error => {
        this.spinner.hide();
      });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  // clear the search
  clearFilter(value1) {
    if (value1 == false) {
      this.counter = this.counter - 1;
      //  this.addUserForm.controls['addUserBlockLocation'].reset();
    }
    else {
      this.counter = this.counter + 1;
    }
  }

  /* Calling API based on selected Tabs*/
  onSelect(event) {
    this.activeTab = event.heading;
  }





  // /*redraw the datatable*/
  // reploatingDataTable(value) {
  //   let table;
  //   if (value == 'datatable1') {
  //     table = $("#dataTable1").DataTable();
  //   } else if (value == 'datatable2') {
  //     table = $("#dataTable2").DataTable();
  //   } else {
  //     table = $("#dataTable3").DataTable();
  //   }
  //   table.destroy();
  // }

  /**
  * deleteGrievance(Grievance)
  * @param template 
  * @param delUndoGdata 
  */
  deletGrievanceModal(template: TemplateRef<any>, delUndoGdata: any, value: string, grievanceId: string) {
    this.delUndoGrievnceData = delUndoGdata
    this.griId = grievanceId;
    if (value == 'undo') {
      this.delUndoGrievnceHeading = 'Move Grievance'
      this.popUpCnfMessage = 'Are you sure you want to move the grievance to list of new grievances ?'
      this.gStatus = 'pending'
    } else if (value == 'reject') {
      this.delUndoGrievnceHeading = 'Reject Grievance'
      this.popUpCnfMessage = 'Are you sure you want to reject the grievance ?'
      this.gStatus = 'rejected'
    } else {
      this.delUndoGrievnceHeading = 'Accept Grievance'
      this.popUpCnfMessage = 'Are you sure you want to accept the grievance ?'
      this.gStatus = 'accepted'
    }
    this.modalRef = this.modalService.show(template);
  }

  /*Redirect to modify-grievance Page */
  editGrievance(formData) {
    this.dataService.editGrievanceDetails = "editGrievanceDetails";
    this.dataService.getGrievanceDetails(formData)
    this.route.navigate(['/grievance-register'])

  }

  /* Function for Accepting the Grievance*/
  grievanceStatus(id, status, value, gSValue) {
    let data: any = {
      "status": status
    }
    this.spinner.show();
    if (gSValue == 'hidePopup') {
      this.modalRef.hide();
    }
    if (value) {
      this.masterService.putGrievanceActions('supervisor/grievance_update_status/', id, data).subscribe(
        (response: any) => {
          if (response.data.status) {
            this.spinner.hide();
            // if (status == "accepted") {
            //   this.getAllAcceptedGrievanceData(this.data);
            // }
            // else if (status == "rejected") {
            //   this.getAllRejectedGrievanceData(this.data);
            // } else {
            //   this.getAllRejectedGrievanceData(this.data);
            // }
            this.getAllNewGrievanceData(this.data);
            this.commonHelper.toasterMessage(response.message);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } else {
      this.spinner.hide();
      this.modalRef.hide();
    }
  }



  onAddCategoryChange(event: any, value) {
    this.natureId = undefined
    this.adminDashBoardForm.controls['filterGrievanceNature'].reset();
    if (event) {
      this.gId = event.grievanceTypeId;
      if (typeof (event.grievanceTypeId) == 'string') {
        this.gId = 0
      }
      // this.getMatrixData(event.grievanceTypeId, this.natureId, this.stateId);
      this.getGrievanceNature1(this.gId);
    } else {
      this.gId = 1;
    }
  }


  getGrievanceNature1(id) {
    //this.apiCalling('active_grievanceNature', id)
    try {
      this.spinner.show();
      this.masterService.getData('active_grievanceNature/', id).subscribe((response: any) => {
        if (response.status) {
          let newData = [];
          this.spinner.hide();
          response.data.filter(newResponse => {
            newData.push({ id: newResponse.grievanceNatureId, name: newResponse.grievanceNatureName });
          });
          if (newData.length > 0) {
            this.spinner.hide();
            this.categoriesNature1 = newData;
          } else {
            this.categoriesNature1 = [];
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
      })

    } catch (excp) {
      this.spinner.hide();
    }
  }

  onNatureChange(value) {
    this.selectedNature = value
    this.natureId = value.id;
    //  this.getLevels(this.gId, this.natureId, CommonConstants.stateId);
    // this.getMatrixData(this.gId, this.natureId, this.stateId);
  }

}
